import { EMessageDirection, type IMessage } from 'src/services/api/messages/types';

/**
 * Whether this conversation still has something to mark as read.
 * Outbound messages are always read (enforced by a DB constraint), so only
 * inbound ones can leave a conversation unread.
 */
export function hasUnreadMessages(messages: IMessage[] | undefined): boolean {
    return Boolean(messages?.some(
        (message) => message.direction === EMessageDirection.IN && !message.is_read_by_landlord
    ));
}
